<template>
	<v-container class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" class="text-center">
				<v-progress-circular v-if="!errore" indeterminate color="primary" size="64"></v-progress-circular>
				<p v-if="!errore" class="mt-4 subtitle-1">Accesso in corso...</p>
				<v-alert v-else type="error" text class="d-inline-block">{{ errore }}</v-alert>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'sso-callback',
		data() {
			return {
				errore: null,
			}
		},

		methods: {
			messaggioErrore(codice) {
				const messaggi = {
					utente_inesistente: 'Nessun utente di questo gestionale corrisponde al tuo account.',
					utente_barrato: 'Il tuo utente e\' disabilitato.',
					tipo_non_ammesso: 'Accesso non consentito per questo tipo di account.',
					stato_non_valido: 'La richiesta di accesso e\' scaduta. Riprova.',
					consenso_negato: 'Consenso non concesso.',
				}

				return messaggi[codice] || 'Accesso non riuscito. Riprova.'
			},
		},

		created() {
			this.$store.commit('endProgress')

			const errore = this.$route.query.sso_error
			const ticket = this.$route.query.ticket

			if (errore) {
				this.errore = this.messaggioErrore(errore)
				setTimeout(() => this.$router.replace('/login'), 4000)
				return
			}

			if (!ticket) {
				this.$router.replace('/login')
				return
			}

			this.axios.post('sso/exchange', { ticket: ticket }).then(response => {
				this.$store.commit('AUTH_SUCCESS', { token: response.data.data.token })

				this.$store.dispatch('USER_REQUEST').then(() => {
					this.$router.replace('/')
				}).catch(() => {
					// Il token e' gia' nello store: un semplice redirect a /login
					// verrebbe rimbalzato dalla guardia ifNotAuthenticated su '/',
					// e si finirebbe in dashboard senza profilo caricato. La
					// mutation azzera token e cache di sessione e porta al login
					// da se'.
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Accesso non riuscito: riprova.', value: true, color: 'error'})
					this.$store.commit('AUTH_LOGOUT')
				})
			}, () => {
				this.errore = 'Accesso non riuscito. Riprova.'
				setTimeout(() => this.$router.replace('/login'), 4000)
			})
		},
	}
</script>
